import React from 'react';
import { Row, Col } from 'react-bootstrap';
import TextContent from '../../../_common/TextContent';
import '../EquipmentProfile.scss';

interface EquipmentOriginDetailsProps {
    originType?: string | null;
    originJob?: string | null;
    originLofa?: string | null;
    originYard?: string | null;
    originLongitude?: number | null;
    originLatitude?: number | null;
    originRegion?: string | null;
    originDistrict?: string | null;
}

const EquipmentOriginDetails = ({
    originType,
    originJob,
    originLofa,
    originYard,
    originLongitude,
    originLatitude,
    originRegion,
    originDistrict,
}: EquipmentOriginDetailsProps): React.ReactElement => {
    return (
        <Col>
            <Row className="EquipmentsDetails-Title">Origin Details</Row>
            <Row>
                <TextContent hasTopMargin title={'Origin Type: '} value={originType || ''} />
            </Row>
            {originType === 'Job' && (
                <Row>
                    <TextContent hasTopMargin title={'Origin: '} value={originJob || ''} />
                </Row>
            )}
            {originType === 'Lofa' && (
                <Row>
                    <TextContent hasTopMargin title={'Origin Lofa: '} value={originLofa || ''} />
                </Row>
            )}
            {originType === 'Yard' && (
                <Row>
                    <TextContent hasTopMargin title={'Origin Yard: '} value={originYard || ''} />
                </Row>
            )}
            {originType === 'Other' && (
                <>
                    <Row>
                        <TextContent hasTopMargin title={'Origin Longitude: '} value={originLongitude?.toString() || ''} />
                    </Row>
                    <Row>
                        <TextContent hasTopMargin title={'Origin Latitude: '} value={originLatitude?.toString() || ''} />
                    </Row>
                </>
            )}
            <Row>
                <TextContent hasTopMargin title={'Origin Region: '} value={originRegion || ''} />
            </Row>
            <Row>
                <TextContent hasTopMargin title={'Origin District: '} value={originDistrict || ''} />
            </Row>
        </Col>
    );
};

export default EquipmentOriginDetails;
